export default "__VITE_ASSET__004c3023__"